import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsBandsintownComponent } from './simple-icons-bandsintown.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsBandsintownComponent ],
    exports:      [ SimpleIconsBandsintownComponent ],
    bootstrap:    []
})
export class SimpleIconsBandsintownModule {}
